export default "__VITE_ASSET__DzTBtXm0__"